import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useToast } from '@/hooks/useToast';
import { consumeSseStream } from '@/lib/api';

export const useScoreJob = () => {
  const queryClient = useQueryClient();
  const { push } = useToast();

  return useMutation({
    mutationFn: async (jobId: number) => {
      const res = await fetch(`/api/jobs/${jobId}/score`, { method: 'POST' });

      if (!res.ok) {
        throw new Error(`${res.status} ${res.statusText}`);
      }

      return consumeSseStream(res, {} as { score?: number; status?: string });
    },
    onError: (error: Error) => push(error.message || 'Score failed', 'error'),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['jobs'] });
      queryClient.invalidateQueries({ queryKey: ['stats'] });
      push('Job scored', 'success');
    },
  });
};
